import { CreateTimeSetQueryParamsType } from '@/common/queries/createTimeSet/createTimeSetQuery.type';
import { createTimeSetFunction } from '@/common/queries/createTimeSet/createTimeSetQueryFunction';
import { useMutation } from '@tanstack/react-query';

export const useCreateTimeSetQueryOptions = () => {
  return useMutation({
    mutationKey: ['createTimeSetQueryOptions'],
    mutationFn: (params: CreateTimeSetQueryParamsType) =>
      createTimeSetFunction(params),
  });
};
